import { useEffect, useState } from "react";
import { Send, Mail } from "lucide-react";
import { toast } from "sonner";
import { api, formatErr } from "@/lib/api";

export default function WeeklyIssues() {
  const [issues, setIssues] = useState([]);
  const [mc, setMc] = useState(null);
  const load = () => {
    api.get("/admin/weekly").then((r) => setIssues(r.data));
    api.get("/admin/mailchimp/status").then((r) => setMc(r.data));
  };
  const sync = async () => {
    try {
      const { data } = await api.post("/admin/mailchimp/sync");
      toast.success(`${data.synced} subscribers synced to Mailchimp`);
      load();
    } catch (e) {
      toast.error(formatErr(e));
    }
  };
  useEffect(() => {
    load();
  }, []);
  const publish = async () => {
    if (!window.confirm("Publish the next message now? It will also be emailed to your Mailchimp audience if that's switched on. (Save any edits first.)")) return;
    const { data } = await api.post("/admin/weekly/publish");
    if (data?.mailchimp_error) toast.error(`Published on site, but Mailchimp said: ${data.mailchimp_error}`);
    else toast.success(data?.mailchimp_campaign_id ? "Published and emailed via Mailchimp" : "Published");
    load();
  };
  const testWelcome = async () => {
    try {
      const { data } = await api.post("/admin/welcome/test");
      toast.success(`Test welcome email sent to ${data.to}`);
    } catch (e) {
      toast.error(formatErr(e));
    }
  };
  return (
    <div className="mt-12 space-y-4" data-testid="admin-weekly-issues">
      {mc && (
        <div className="flex flex-wrap items-center justify-between gap-3 rounded-2xl bg-bt-sage p-4" data-testid="mailchimp-status">
          <p className="text-sm text-bt-heading"><b>Mailchimp:</b> {mc.connected ? `connected · ${mc.synced} of ${mc.total} subscribers synced` : "not connected"}</p>
          {mc.connected && <button onClick={sync} className="btn-ghost text-sm" data-testid="mailchimp-sync-button">Sync all subscribers</button>}
        </div>
      )}
      <div className="flex flex-wrap gap-2">
        <button onClick={publish} className="btn-primary !min-h-[44px] text-sm" data-testid="weekly-publish-now"><Send size={15} /> Publish next message now</button>
        <button onClick={testWelcome} className="btn-secondary !min-h-[44px] text-sm" data-testid="welcome-send-test"><Mail size={15} /> Send me a test welcome email</button>
      </div>
      <p className="text-xs text-bt-sagedeep">Every Monday at 8am UTC the next message is published at /weekly, shown on the homepage and dashboard, and emailed to your Mailchimp audience.</p>
      <h3 className="pt-4 text-xl">Published messages</h3>
      <div className="divide-y divide-[color:var(--bt-border)] rounded-2xl border border-bt-border bg-white">
        {issues.map((i) => (
          <div key={i.id} className="p-4" data-testid={`weekly-issue-${i.week}`}>
            <p className="font-semibold text-bt-heading">{i.subject}</p>
            <p className="text-sm text-bt-sagedeep">{i.week} · {i.kind === "affirmation" ? "Monthly affirmation" : i.theme} · {i.mailchimp_campaign_id ? "Emailed via Mailchimp" : i.mailchimp_error ? `Mailchimp error: ${i.mailchimp_error}` : i.forwarded ? "Sent to webhook" : "Published on site"}</p>
          </div>
        ))}
        {!issues.length && <p className="p-5 text-sm">Nothing published yet.</p>}
      </div>
    </div>
  );
}
